module.exports = __webpack_public_path__ + "img/20200420144534319.b1f9900b.png";